import React from 'react';
import { File as ParsedDiffFile } from '@/types/parse-diff';

interface FileHeaderProps {
  file: ParsedDiffFile;
}

const getFilePath = (file: ParsedDiffFile) => {
  if (file.renamed) {
    return `${file.from} → ${file.to}`;
  }
  if (file.deleted) {
    return file.from;
  }
  return file.to;
};


const FileHeader: React.FC<FileHeaderProps> = ({ file }) => {
  return (
    <div className="flex items-center justify-between p-2 text-xs border-b bg-muted/50">
      <p className="font-bold text-foreground">{getFilePath(file)}</p>
      {!file.binary && (
        <div className="flex items-center space-x-4">
          <span className="font-semibold text-green-500">
            +{file.additions || 0}
          </span>
          <span className="font-semibold text-red-500">
            -{file.deletions || 0}
          </span>
        </div>
      )}
    </div>
  );
};

export default FileHeader;
